import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext'
import { CartProvider } from './context/CartContext'
import Loading from './components/Loading';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.Suspense fallback={<Loading/>}>
    <HelmetProvider>
        <UserProvider>
          <CartProvider>
            <ToastContainer />
            <App />
          </CartProvider>
        </UserProvider>
      </HelmetProvider>
    </React.Suspense>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
